<div class="cvdp-dd" *ngIf="!inline" ngbDropdown display="dynamic" placement="bottom-start bottom-end top-start"
  [autoClose]="'outside'" (openChange)="onOpenChange($event)">

  <button type="button" id="cvdpAreaTrigger" class="cvdp-dd__trigger" ngbDropdownToggle
    [disabled]="disabled || busy"
    [attr.aria-busy]="busy"
    [attr.aria-label]="busy ? 'Loading areas' : ('Area: ' + (selectedArea ? selectedArea.AreaName : 'none selected'))">
    <i class="cvdp-dd__icon" aria-hidden="true"
      [class.fas]="true" [class.fa-map-marker-alt]="!busy"
      [class.fa-spinner]="busy" [class.fa-spin]="busy"></i>
    <span class="cvdp-dd__value" [class.cvdp-dd__value--muted]="busy || !selectedArea">{{ triggerLabel }}</span>
    <i class="fas fa-chevron-down cvdp-dd__caret" aria-hidden="true"></i>
  </button>

  <div ngbDropdownMenu aria-labelledby="cvdpAreaTrigger" class="cvdp-dd__menu cvdp-area"
    [class.cvdp-area--step-areas]="mobileStep == 'areas'">
    <ng-container *ngTemplateOutlet="areaPanel"></ng-container>
  </div>
</div>

<!-- Inline rendering for the mobile sheet: the same panel, on the page rather than
     behind a trigger. -->
<div class="cvdp-area cvdp-area--inline" *ngIf="inline"
  [class.cvdp-area--step-areas]="mobileStep == 'areas'">
  <ng-container *ngTemplateOutlet="areaPanel"></ng-container>
</div>

<ng-template #areaPanel>

    <!-- Panel header: search toggle, or the search field itself -->
    <div class="cvdp-area__header">
      <ng-container *ngIf="!searchMode">
        <span class="cvdp-area__header-title">Browse system levels</span>
        <button *ngIf="allowSearch" type="button" class="cvdp-area__header-action" (click)="toggleSearch()">
          <i class="fas fa-search me-2" aria-hidden="true"></i>Search all areas
        </button>
      </ng-container>
      <ng-container *ngIf="searchMode">
        <div class="cvdp-area__search">
          <i class="fas fa-search cvdp-area__search-icon" aria-hidden="true"></i>
          <label class="visually-hidden" for="cvdpAreaSearch">Search for an area</label>
          <input #searchInput id="cvdpAreaSearch" type="text" class="cvdp-area__search-input"
            [formControl]="searchControl" placeholder="Search for an area..." autocomplete="off" />
          <i class="fas fa-spinner fa-spin cvdp-area__search-spinner" *ngIf="searchLoading" aria-hidden="true"></i>
        </div>
        <button type="button" class="cvdp-area__header-action" (click)="toggleSearch()">Cancel</button>
      </ng-container>
    </div>

    <!-- Search results -->
    <div class="cvdp-area__results" *ngIf="searchMode">
      <p class="cvdp-dd__empty" *ngIf="!searchTerm">Type at least {{ minSearchChars }} characters to search.</p>
      <p class="cvdp-dd__empty" *ngIf="searchTermTooShort">Keep typing, at least {{ minSearchChars }} characters are needed.</p>
      <p class="cvdp-dd__empty" *ngIf="!searchLoading && !searchTermTooShort && searchTerm && searchResults?.length === 0">
        No areas match that search.
      </p>
      <p class="cvdp-dd__empty" *ngIf="searchError">
        Search is unavailable at the moment. Browse the system levels instead.
      </p>
      <button *ngFor="let area of searchResults; trackBy: trackByAreaId" type="button" class="cvdp-area__item"
        [class.cvdp-area__item--selected]="isSelectedArea(area)" (click)="selectArea(area, true)">
        <span class="cvdp-area__badge">{{ area.SystemLevelName }}</span>
        <span class="cvdp-area__item-label">
          {{ area.AreaName }}<ng-container *ngIf="area.SystemLevelID == 5"> ({{ area.AreaCode }})</ng-container>
        </span>
      </button>
    </div>

    <!-- Browse: system levels then their areas -->
    <div class="cvdp-area__columns" *ngIf="!searchMode">

      <div class="cvdp-area__col cvdp-area__col--levels" role="group" aria-label="System levels">
        <div class="cvdp-dd__loading" *ngIf="levelsLoading && !systemLevels?.length">
          <i class="fas fa-spinner fa-spin me-2" aria-hidden="true"></i>Loading...
        </div>
        <p class="cvdp-dd__empty" *ngIf="systemLevels?.length === 0">No system levels for this period.</p>
        <button #levelButton *ngFor="let level of systemLevels; let i = index; trackBy: trackBySystemLevelId" type="button"
          class="cvdp-area__level"
          [class.cvdp-area__level--active]="isActiveLevel(level)"
          [attr.aria-expanded]="isActiveLevel(level)"
          (click)="onLevelClick(level)"
          (mouseenter)="onLevelEnter(level)"
          (mouseleave)="onLevelLeave()"
          (keydown)="onLevelKeydown($event, i)">
          <span class="cvdp-area__level-label">{{ level.SystemLevelName }}</span>
          <i class="fas fa-chevron-right cvdp-area__level-caret" aria-hidden="true"></i>
        </button>
      </div>

      <div class="cvdp-area__col cvdp-area__col--areas" role="group"
        [attr.aria-label]="activeLevel ? activeLevel.SystemLevelName + ' areas' : 'Areas'">

        <button type="button" class="cvdp-area__back d-md-none" *ngIf="activeLevel" (click)="backToLevels()">
          <i class="fas fa-chevron-left me-2" aria-hidden="true"></i>{{ activeLevel.SystemLevelName }}
        </button>

        <div class="cvdp-area__filter" *ngIf="showLevelFilter">
          <i class="fas fa-search cvdp-area__search-icon" aria-hidden="true"></i>
          <label class="visually-hidden" for="cvdpLevelFilter">Search within {{ activeLevel.SystemLevelName }}</label>
          <input id="cvdpLevelFilter" type="text" class="cvdp-area__search-input"
            [value]="levelFilter" (input)="onLevelFilterChange($any($event.target).value)"
            [placeholder]="'Search ' + activeLevel.SystemLevelName + '...'" autocomplete="off" />
        </div>

        <p class="cvdp-dd__empty" *ngIf="!activeLevel">Choose a system level to see its areas.</p>

        <div class="cvdp-dd__loading" *ngIf="activeLevel && areasLoading">
          <i class="fas fa-spinner fa-spin me-2" aria-hidden="true"></i>Loading areas...
        </div>

        <p class="cvdp-dd__empty" *ngIf="activeLevel && !areasLoading && awaitingSearch">
          Start typing to find a practice. If a practice is not listed, it did not participate in providing data.
        </p>

        <p class="cvdp-dd__empty" *ngIf="activeLevel && !areasLoading && !awaitingSearch && matchCount === 0">
          No areas match that search.
        </p>

        <button #areaButton *ngFor="let area of visibleAreas; let i = index; trackBy: trackByAreaId" type="button"
          class="cvdp-area__item"
          [class.cvdp-area__item--selected]="isSelectedArea(area)"
          (click)="selectArea(area, false)"
          (keydown)="onAreaKeydown($event, i)">
          <span class="cvdp-area__item-label">
            {{ area.AreaName }}<ng-container *ngIf="area.SystemLevelID == 5"> ({{ area.AreaCode }})</ng-container>
          </span>
        </button>

        <p class="cvdp-area__note" *ngIf="truncated">
          Showing the first {{ maxRenderedAreas }} of {{ matchCount }}. Refine your search to narrow the list.
        </p>

        <p class="cvdp-area__note" *ngIf="activeLevel && isPracticeLevel(activeLevel) && !awaitingSearch">
          If a practice is not listed, it did not participate in providing data.
        </p>

      </div>
    </div>

</ng-template>
